export const prettyPrintPhoneNumber = (phoneNumber) => {
  if (phoneNumber.length !== 10) return phoneNumber
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3')
}

export const formatToPhone = (value) => {
  if (!value) return ''
  const input = value.replace(/\D/g, '').substring(0, 10) // First ten digits of input only
  const areaCode = input.substring(0, 3)
  const middle = input.substring(3, 6)
  const last = input.substring(6, 10)

  if (input.length > 6) {
    return `(${areaCode}) ${middle}-${last}`
  } else if (input.length > 3) {
    return `(${areaCode}) ${middle}`
  } else if (input.length > 0) {
    return `(${areaCode}`
  }
}
